document.addEventListener('DOMContentLoaded', function () {

  // ── CART COUNT ────────────────────────────────────────────
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count, #cart-count, #cart-count-mobile').forEach(function (el) {
      el.textContent = count;
      if (el.dataset) el.dataset.count = count;
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); });
  }
  fetchCartCount();

  // ── CART DRAWER ───────────────────────────────────────────
  window.openCartDrawer = function () {
    document.getElementById('cart-drawer').classList.add('open');
    document.getElementById('cart-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  };

  window.closeCartDrawer = function () {
    document.getElementById('cart-drawer').classList.remove('open');
    document.getElementById('cart-overlay').classList.remove('open');
    document.body.style.overflow = '';
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderCartDrawer() {
    var itemsEl = document.getElementById('cart-drawer-items');
    var footerEl = document.getElementById('cart-drawer-footer');
    itemsEl.innerHTML = '<div class="cart-drawer__loading">Loading…</div>';
    footerEl.style.display = 'none';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);

        if (cart.item_count === 0) {
          itemsEl.innerHTML =
            '<div class="cart-drawer__empty">' +
            '<i class="ti ti-shopping-bag" style="font-size:40px;opacity:0.2;display:block;margin-bottom:12px;"></i>' +
            '<p>Your cart is empty.</p>' +
            '<a href="/collections/all" class="cart-drawer__shop-link" onclick="closeCartDrawer()">Browse Jerseys →</a>' +
            '</div>';
          return;
        }

        var html = '';
        cart.items.forEach(function (item) {
          html +=
            '<div class="cart-drawer__item" data-key="' + item.key + '">' +
            '<div class="cart-drawer__item-img">' +
            (item.image
              ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_120x120$1') + '" alt="' + item.title + '">'
              : '<div style="width:100%;height:100%;background:var(--light-tan);display:flex;align-items:center;justify-content:center;font-size:22px;">👕</div>') +
            '</div>' +
            '<div class="cart-drawer__item-info">' +
            '<div class="cart-drawer__item-title">' + item.product_title + '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>' : '') +
            '<div class="cart-drawer__item-row">' +
            '<div class="cart-drawer__qty">' +
            '<button onclick="updateQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')" aria-label="Decrease quantity">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button onclick="updateQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="cart-drawer__item-price">' + formatMoney(item.line_price) + '</div>' +
            '</div>' +
            '<button class="cart-drawer__remove" onclick="updateQty(\'' + item.key + '\', 0)">Remove</button>' +
            '</div>' +
            '</div>';
        });
        itemsEl.innerHTML = html;

        document.getElementById('cart-drawer-total').textContent = formatMoney(cart.total_price);
        footerEl.style.display = 'flex';
      });
  }

  window.updateQty = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { renderCartDrawer(); });
  };

  // ── ADD TO CART (opens drawer) ────────────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function (r) { return r.json(); })
        .then(function () {
          openCartDrawer();
        });
    });
  });

  // ── TOAST ─────────────────────────────────────────────────
  window.showToast = function (msg) {
    var toast = document.getElementById('site-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'site-toast';
      toast.style.cssText = 'position:fixed;bottom:24px;right:24px;background:#444;color:#F7F4EE;padding:12px 18px;font-family:IBM Plex Mono,monospace;font-size:11px;letter-spacing:1px;opacity:0;transform:translateY(10px);transition:opacity 0.3s,transform 0.3s;z-index:9999;pointer-events:none;';
      document.body.appendChild(toast);
    }
    toast.textContent = '✓ ' + msg;
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(10px)';
    }, 2500);
  };

});
